"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDate = void 0;
const assertString_1 = require("./util/assertString");
function toDate(date) {
    (0, assertString_1.assertString)(date);
    const value = Date.parse(date);
    return !isNaN(value) ? new Date(value) : null;
}
exports.toDate = toDate;
